import { render } from "./Advertisers.vue?vue&type=template&id=a3b2499c"
import script from "./Advertisers.vue?vue&type=script&lang=js"
export * from "./Advertisers.vue?vue&type=script&lang=js"

import "./Advertisers.vue?vue&type=style&index=0&id=a3b2499c&lang=css"
script.render = render

export default script